/// <reference path="../../../../tools/typings/angularjs/angular.d.ts"/>
/// <reference path="../../components.ts"/>

module DealerwareWebComponents {
    "use strict";

    import Languages = DealerwareWebComponents.Languages;

    export class CustomerContractsDirectiveController {
        public static $inject : string[] = [
            '$timeout',
            '$state',
            '$filter',
            '$dealerwareNotification',
            '$dealerwareLoading',
            'routeShortcuts',
            '$dealerwareInternationalizationData'
        ];

        public customer: any;
        public columns: any;
        public onRecordClick: any;
        public loader: any;
        public labels: {};

        constructor(public $timeout: any,
                    public $state: any,
                    public $filter: any,
                    public $dealerwareNotification: any,
                    public $dealerwareLoading: any,
                    public routeShortcuts: any,
                    public $dealerwareInternationalizationData: any) {
            this.getLabels('customers');
            this.initColumns();
        }

        public getLabels(module: string) : void {
            const _self = this;
            this.$dealerwareInternationalizationData
                .getLabels()
                .then( function(res) {
                    _self.labels = _self.$dealerwareInternationalizationData.getLabelsByModule(res.data, module);
                },
                function(error: any) {
                    this.$dealerwareNotification.apiError(error);
                }
            );
        }

        public pageTransitionError(response: any) : void {
            this.loader.close();
            this.$dealerwareNotification.apiError(response);
        }

        public initColumns() : void {
            var _self = this;

            this.columns = [{
                key: 'id',
                hidden: true
            },{
                key: 'confirmation_token',
                header: 'Contract ID',
                id: 'customer-details-contract-id',
                onClick: function(e: any, contract: any) {
                    $(e.target).attr('href', _self.$state.href(
                        _self.routeShortcuts['contractDetails'].target,
                        { contractId: contract.data.id }
                    ));
                }
            },{
                key: 'balance',
                header: 'Balance',
                onClick: function(e: any, contract: any) {
                    $(e.target).attr('href', _self.$state.href(
                        _self.routeShortcuts['contractPricing'].target,
                        { contractId: contract.data.id }
                    ));
                },
                dataFilter: (balance: string) => {
                    return _self.$dealerwareInternationalizationData.getCurrencyLabel(balance);
                },
            },{
                key: 'effective_pickup_display',
                header: 'Pickup',
                dataFilter: (pickUpDate: string) => {
                    return _self.$filter('filterInternationalizationDate')(pickUpDate);
                },
            },{
                key: 'effective_dropoff_display',
                header: 'Dropoff',
                dataFilter: (dropOffDate: string) => {
                    return _self.$filter('filterInternationalizationDate')(dropOffDate);
                },
            },{
                key: 'current_state',
                header: 'Status',
                dataFilter: (v: string) => _self.$filter('titlecase')(_self.getStateLabelDict(v))
            }];
        }

        private getStateLabelDict(state: string) {
            return (this.labels && this.labels.contracts) ? this.labels.contracts.status[state] : '';
        }
    }

    getDealerwareWebComponentsModule().controller('CustomerContractsDirectiveController', CustomerContractsDirectiveController);


    export class CustomerContractsDirective implements ng.IDirective {

        public restrict         : string    =   'EA';
        public controller       : any       =   'CustomerContractsDirectiveController';
        public controllerAs     : string    =   'customerContractsController'    ;
        public bindToController : boolean   =   true;
        public replace          : boolean   =   false;
        public scope            : Object    =   { customer: '=' };
        public transclude       : boolean   =   false;
        public templateUrl      : string    =   '/components/customer/contracts/customer_contracts_directive.html';
        public static $inject   : string[]  =   [];

        constructor() {
        }

        public link : ng.IDirectiveLinkFn = (
            scope   :   ng.IScope,
            element :   ng.IAugmentedJQuery,
            attrs   :   ng.IAttributes,
            ctrls   :   any
        ) => {
        }

    }

    // register the directive
    getDealerwareWebComponentsModule().directive("dealerwareCustomerContracts",() => new CustomerContractsDirective());

}
